import qs from 'qs';
import axios from 'axios';
import { call } from 'redux-saga/effects';
import { LOGIN_ENDPOINT, REGISTER_ENDPOINT, SEND_TEMPORARY_PASSWORD_ENDPOINT, RESET_PASSWORD_ENDPOINT, API_URL, CHANGE_PASSWORD_ENDPOINT } from '../config/apiEndpoints';
import { getDefaultHeaders as headers } from '../helpers/api.helper';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;

export function* login(payload) {

    const body = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        grant_type: 'password',
        scope: 'simple_user',
        username: payload.email,
        password: payload.password
    };

    return yield call(axios.post, LOGIN_ENDPOINT, qs.stringify(body), headers());
}

export function* register(payload) {
    const header = tokenHeader();
    return yield call(axios.post, REGISTER_ENDPOINT, payload, header);
}

export function* sendTemporaryPassword(payload) {
    const header = tokenHeader();
    return yield call(axios.post, SEND_TEMPORARY_PASSWORD_ENDPOINT, payload, header);
}

export function* resetPassword(payload) {
    const header = tokenHeader();
    return yield call(axios.post, RESET_PASSWORD_ENDPOINT, payload, header);
}

export function* changePassword(payload) {
    const header2 = {
        headers: {
            'Content-Type': 'application/hal+json',
            'Authorization': 'Bearer ' + localStorage.getItem("access_token"),     
        } 
    }
    const userId = localStorage.getItem("user_id");
    const body = {
        "_links": {
            "type": {
                "href": API_URL + "rest/type/user/user"
            }
        },
        "pass": [
            {
              "existing":payload.old_password, 
              "value": payload.new_password
            }
        ]
    }
    const url =  CHANGE_PASSWORD_ENDPOINT + `${userId}?_format=hal_json`;

    return yield call(axios.patch, url, body, header2);
}

export function* loginGuest() {

    const body = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        grant_type: 'client_credentials'
    };

    return yield call(axios.post, LOGIN_ENDPOINT, qs.stringify(body), headers() );
}

export function* loginFacebook(payload) {
    const body = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        grant_type: 'facebook',
        scope: 'simple_user',
        facebook_token: payload.tokenDetail.accessToken
    };
    return yield call(axios.post, LOGIN_ENDPOINT, qs.stringify(body), headers() );
}

export function* refreshTokenLogin(payload) {
    const body = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        grant_type: 'refresh_token',
        refresh_token: payload
    };

    return yield call(axios.post, LOGIN_ENDPOINT, qs.stringify(body), headers());
}

export function* loginGoogle(payload) {
    const body = {
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        grant_type: 'google',
        scope: 'simple_user',
        google_token: payload.accessToken
    }

    return yield call(axios.post, LOGIN_ENDPOINT, qs.stringify(body), headers());
}


// WEBPACK FOOTER //
// ./src/SHARED/api/user.api.js